<template>
	<div class="comp">
		<el-dialog title="换货" :visible.sync="dialog_state" width="1500px">
			<el-form @submit.native.prevent>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="是否入库：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.backState">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2" disabled>否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="换货备注：" :label-width="formLabelWidth">
							<el-input style="width:400px;" type="textarea" v-model="form.backRemark" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col>
						<el-input style="width:400px;margin-left:0;" v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput">
							<template slot="prepend">录入条码</template>
						</el-input>
						<el-table :data="tableData" max-height='800' default-expand-all style="width: 100%;margin-bottom: 20px;" row-key="tableKey">
							<el-table-column type="expand">
								<template slot-scope="props">
									<div >
										<div v-if="!$public.isNull(props.row.goodsList)">
											<el-tag style="margin: 5px;" v-for="item in props.row.goodsList" :key="item.tableKey" :closable="props.row.goodsType!==8" @close="del_goods(item)">
												<span v-if="props.row.goodsType===8">{{item.goodsName}} {{item.skuValue}}</span>
												{{item.customCode}}
											</el-tag>
										</div>
										<div v-else>无条码</div>
									</div>
									<!-- <div v-if="!$public.isNull(props.row.giftList)">
										<el-table :data="props.row.giftList" style="width: 100%;margin-bottom: 20px;" size="mini" row-key="tableKey" :empty-text="'没有录入赠品'">
											<el-table-column label="赠品名称" min-width="150">
												<template slot-scope="giftItem">
													{{giftItem.row.goodsName}}
												</template>
											</el-table-column>
											<el-table-column label="赠品规格" min-width="150">
												<template slot-scope="giftItem">
													{{giftItem.row.skuValue}}
												</template>
											</el-table-column>
											<el-table-column label="赠品数量" min-width="150">
												<template slot-scope="giftItem">
													{{giftItem.row.num}}
													<el-tooltip
													style="margin:4px;"
													effect="dark"
													placement="top"
													>
														<div slot="content">
															<span v-for="tm in giftItem.row.goodsList" :key="tm.customCode">{{tm.customCode}} </span>
														</div>
														<span style="cursor: pointer;">条码</span>
													</el-tooltip>
												</template>
											</el-table-column>
										</el-table>
									</div> -->
								</template>
							</el-table-column>
							<el-table-column prop="goodsName" label="商品名称" width="300">
							</el-table-column>
							<el-table-column prop="skuValue" label="规格" width="100">
							</el-table-column>
							<el-table-column prop="unit" label="单位" width="80">
							</el-table-column>
							<el-table-column prop="originalPrice" label="标准价" width="100">
							</el-table-column>
							<el-table-column prop="activityName" label="活动" >
								<template slot-scope="scope">
									<el-select
									v-model="scope.row.activityId"
									@change="changeActivityId(scope.row)"
									placeholder="请选择"
									size="mini"
									style="width:180px;"
									clearable>
										<el-option
										v-for="item in scope.row.activityList"
										:key="item._id"
										:label="item.name"
										:value="item._id"
										></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="优惠价" width="80">
							</el-table-column>
							<el-table-column prop="num" label="数量" width="80">
							</el-table-column>
							<el-table-column label="总金额" width="100">
								<template slot-scope="scope">
									{{$public.cheng(scope.row.price,scope.row.num)}}
								</template>
							</el-table-column>
							<el-table-column   label="操作" width="120">
								<template slot-scope="scope">
									<span>
										<span>
											<img class="btn_operate" @click="del_goods(scope.row)" src="../../../../assets/img/shanchu.png" >
										</span>
										<span v-if="!$public.isNull(scope.row.activityItem)&&scope.row.activityItem.consume_type===2" @click="changeGiftList(scope.row)">
											赠品
										</span>
									</span>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="3" :offset="18">
						退货总金额：{{returnTotalMoney}}
					</el-col>
					<el-col :span="3">
						换货总金额：{{totalMoney}}
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogWay_state" :close-on-click-modal="false" :show-close="false" :width="'300px'">
			<div slot="title">
				<span>售卖方式</span>
			</div>
			<div style="font-size: 16px;color:red;margin-bottom:25px;text-align: center;">{{dialogWay_obj.packingExchangesStr}}</div>
			<el-radio-group v-model="dialogWay_curId" style="text-align: center;width:100%;">
				<el-radio
				:label="item.packing_way_id"
				v-for="(item,index) in dialogWay_obj.saleWays"
				:key="index"
				>
					{{item.packing_way_name}}
				</el-radio>
			</el-radio-group>
			<div slot="footer">
				<el-row style="text-align: center;">
					<el-button type="cancel" @click="cancel_dialogWay">取消</el-button>
					<el-button type="success" @click="submit_dialogWay">确定</el-button>
				</el-row>
			</div>
		</el-dialog>
		<!-- 赠品 -->
		<div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div>
	</div>
</template>
<script>
	import setGift from "../../../../components/drawer/setGift.vue"
	import delSale from '../../../../util/delSale.js'
	export default {
		components:{setGift},
		data() {
			return {
				dialog_state: true,
				formLabelWidth: '100px',
				form:{
					backState:1,
					backRemark:'',
				},
				o:null,
				scanningCodeInput:"",
				tableData:[],
				totalMoney:0,// 录入商品总价
				// 售卖方式
				dialogWay_state:false,
				dialogWay_obj:{},
				dialogWay_curId:'',
				// 用户
				userInfo:{},
				// 赠品
				curIndex:-1,
				drawerGift_state:false,
				giveGoods:{},
			}
		},
		props:{
			orderDetail:{
				default:()=>{
					return {_id:''}
				}
			},
			returnTotalMoney:{
				default:0,
			},
		},
		mounted() {
			this.o = new delSale();
			this.$http.get('/api/Member/Single', {"id": this.orderDetail.user_info.user_id}).then(res => {
				if(res.code==0){
					this.userInfo = res.data;
				}
			})
		},
		methods: {
			close(){
				this.$emit("submit",{type:"close"})
			},
			/////////////////////////////////////////  赠品
			changeGiftList(row){
				let calcResult=this.$public.calcActivity(row.activityItem,this.$public.cheng(row.originalPrice,row.num),row.num)
				console.log(calcResult)
				row.price = calcResult.newPrice;
				this.curIndex = row.index;
				this.giveGoods = calcResult.gift;
				this.giveGoods.giftTableData = row.giftList;
				this.drawerGift_state = true;
			},
			submit_drawerGift({giftTableData}){
				this.drawerGift_state = false;
				this.o.arr[this.curIndex].giftList = giftTableData;
			},
			// 删除
			del_goods(row){
				if (row.twoIndex === undefined) { // 删 一级
					this.$confirm('确定要删除?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del([row.index, -1]);
						this.tableData = this.o.arr;
						this.getTotal()
					})
				} else { // 删 二级
					this.$confirm('确定要删除?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del([row.oneIndex,row.twoIndex],true);
						this.tableData = this.o.arr;
						this.getTotal()
					})
				}
			},
			// 扫码
			clickScanningCodeInput() {
				this.getScanData(this.scanningCodeInput);
			},
			getScanData(code) {
				this.scanningCodeInput=''
				this.o.searchGoods(code).then((res)=>{
					if(res.saleWays.length>1){ // 多售卖方式
						if(res.useTimes===0){
							this.dialogWay_curId = '';
							this.dialogWay_obj = {
								saleWays:res.saleWays,
								packingExchangesStr:res.packingExchangesStr,
							}
							this.dialogWay_state = true;
						}else{
							let addState = this.o.addGoods();
							if(addState==="true"){
								console.log('添加成功')
							}
							this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
						}
					}else{
						let addState = this.o.addGoods();
						if(addState==="true"){
							console.log('添加成功')
						}
						this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
					}
				})
			},
			///////////////////////////////////////////// 销售单位
			cancel_dialogWay(){
				this.dialogWay_state=false;
			},
			submit_dialogWay(){
				this.dialogWay_state=false;
				let wayItem = this.$public.getMatchingItem(this.dialogWay_obj.saleWays,'packing_way_id',this.dialogWay_curId)
				this.o.curItem.unitId        = wayItem.packing_way_id;
				this.o.curItem.unit          = wayItem.packing_way_name;
				this.o.curItem.originalPrice = wayItem.pprice;
				this.o.curItem.price         = wayItem.pprice;
				this.o.curItem.totalMoney    = wayItem.pprice;
				let addState = this.o.addGoods();
				if(addState==="true"){
					console.log('添加成功')
				}
				this.getActivityListByArr(this.o.arr,this.o.getOneIndex(this.o.curItem))
			},
			// 计算 换货列表 总计
			getTotal(){
				this.totalMoney=0;
				for(let i=0;i<this.tableData.length;i++){
					let t = this.$public.cheng(this.tableData[i].price,this.tableData[i].num)
					this.totalMoney = this.$public.jia(this.totalMoney,t)
				}
			},
			// submit_退换货
			submit(){
				// if(this.detail.order_type==='活体'){
				// 	if(this.form1.backRemark.length<15){
				// 		this.$message({
				// 			message: '退货备注须大于15个字',
				// 			type: 'error'
				// 		});
				// 		return;
				// 	}
				// 	let params = {
				// 		"orderNumber": this.detail.no,
				// 		"remark": this.form1.backRemark,
				// 	}
				// 	let loading = this.$loading();
				// 	this.$http.get('/api/Order/Return/Living', params).then(res => {
				// 		loading.close();
				// 		if (res.code == 0) {
				// 			this.returnOrderId = res.data;
				// 			this.$message({
				// 				message: '操作成功',
				// 				type: 'success'
				// 			});
				// 			this.dialogReturnGoodsState1 = false;
				// 			this.dialogSettlementState = true;
				// 			this.getDetail();
				// 		}
				// 	})
				// 	return ;
				// }
				// if(this.form_table_totalMoney<this.return_totalMoney){
				// 	this.$message({
				// 		message: '换货总金额应大于退货总金额',
				// 		type: 'error'
				// 	});
				// 	return;
				// }
				if(this.form.backRemark.length<15){
					this.$message({
						message: '换货备注须大于15个字',
						type: 'error'
					});
					return;
				}
				let replaceGoods = [];
				for(let i=0;i<this.tableData.length;i++){
					let one = {
						"goodsId": this.tableData[i].goodsId,
						"goodsName": this.tableData[i].goodsName,
						"goodsType": 0,
						"skus": this.tableData[i].skus,
						"skuValue": this.tableData[i].skuValue,
						"model": this.tableData[i].model,
						"unit": this.tableData[i].unit,
						"originalPrice": this.tableData[i].originalPrice,
						"price": this.tableData[i].price,
						"num": this.tableData[i].num,
						"remark": this.tableData[i].remark||'',
						"activityId": this.tableData[i].activityId,
						"activityName": this.tableData[i].activityName,
						goodsList:[],
					}
					for(let a=0;a<this.tableData[i].goodsList.length;a++){
						let two = {
							"goodsId": this.tableData[i].goodsList[a].goodsId,
							"goodsName": this.tableData[i].goodsList[a].goodsName,
							"customBarCode": this.tableData[i].goodsList[a].customCode,
							"specificationPrice": 0,
							"price": this.tableData[i].goodsList[a].price,
							"skus": this.tableData[i].goodsList[a].skus,
							"skuValue": this.tableData[i].goodsList[a].skuValue,
							"model": this.tableData[i].goodsList[a].model,
							"unit": this.tableData[i].goodsList[a].unit,
							"expiryDate": this.tableData[i].goodsList[a].validityStopDate,
						}
						one.goodsList.push(two);
					}
					replaceGoods.push(one);
				}
				this.$emit("submit",{type:'success',data:{form:this.form,table:replaceGoods}})
			},
			// 活动
			changeActivityId(row){
				if(this.$public.isNull(row.activityId)){
					console.log("取消活动")
					row.price = row.originalPrice;
					row.activityItem = {};
					row.giftList = [];
				}else{
					row.activityItem = {};
					row.giftList = [];
					let activityItem = this.$public.getMatchingItem(row.activityList,'_id',row.activityId)
					let calcResult=this.$public.calcActivity(activityItem,this.$public.cheng(row.originalPrice,row.num),row.num)
					console.log(calcResult)
					row.price = calcResult.newPrice;
					row.activityItem = activityItem;
					if(!this.$public.isNull(calcResult.gift.give_list)){
						this.curIndex = row.index;
						this.giveGoods = calcResult.gift;
						this.drawerGift_state = true;
					}
				}
				this.getTotal()
			},
			getActivityListByArr(arr,index){
				this.$util.getActivityOfProduct(this.userInfo,arr).then(res=>{
					for(let i=0;i<arr.length;i++){
						arr[i].activityList=res[i].list;
						if(index>-1){
							if(!this.$public.isNull(res[index].list)&&res[index].list[0].auto_matching>0){
								arr[index].activityId = res[index].list[0]._id;
								arr[index].activityItem = res[index].list[0];
							}
						}
					}
					this.tableData = arr;
					this.getTotal()
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body {
			padding-top: 0;
		}
		
	}
</style>
